import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent implements OnInit {

  @Input () redType = "";
  @Input() control:any;
  @Output() eventCount = new EventEmitter<any>();
  @Input() state:string = "";
  
  constructor() { }

  ngOnInit(): void {

    if(this.control){
      this.control.valueChanges.subscribe((res:any)=>{
        this.eventCount.emit(res.length);
      });
  
    }
    
  }

}
